import * as React from 'react';

import { InversifyContext } from '../context';

export const useService = <ServiceType>(symbol: symbol): ServiceType => {
  const container = React.useContext(InversifyContext);

  return React.useMemo<ServiceType>(() => container.get<ServiceType>(symbol), [container, symbol]);
};
